import {auth, useAuth} from '../use-auth';
import {ReactElement} from 'react';
import {Navigate, Outlet, replace} from 'react-router';
import {getPricingPath} from '@common/billing/pricing-table/pricing-path';
import {isTenantAdmin} from '@common/billing/pricing-table/is-tenant-admin';

interface GuestRouteProps {
  children: ReactElement;
}
export function SubscribedRoute({children}: GuestRouteProps) {
  const {isSubscribed} = useAuth();

  if (!isSubscribed) {
    return <Navigate to={getPricingPath()} replace />;
  }

  return children || <Outlet />;
}

export function subscribedGuard() {
  // Tenant admins don't need subscription guard
  try {
    if (isTenantAdmin()) {
      return null;
    }
  } catch (e) {
    console.error('Error checking tenant admin status:', e);
  }
  
  // Allow manual renew page
  try {
    const pathname = typeof window !== 'undefined' ? window.location.pathname : '';
    if (pathname.startsWith('/billing/renew/manual-razorpay')) {
      return null;
    }
  } catch (e) {
    // ignore and fallback to default check
  }

  if (!auth.isSubscribed) {
    return replace(getPricingPath());
  }

  return null;
}
